export default "__VITE_ASSET__CzedZH_6__"